import React from "react";
import Header from "../../components/InternationalAcademy/Header";
import AboutContent from "../../components/InternationalAcademy/About/index";
const About = () => {
  return (
    <div className="scroll scroll-auto transition-all">
      <Header />
      <AboutContent />
    </div>
  );
};

export default About;
